export default function FlightsListController(
    $scope,
    $controller,
    flightsFactory
) {
    'ngInject';

    $controller('FlightsListBaseController', {
        $scope,
        flightsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsListCtrl.js